import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'

import Noppa from '../../additionalComponents/Noppa.js';
import { data } from './data/data_01_BB_eiPahoiteltuTunkeutumista'
// import kuva from './images/very_pissed.jpg'
import d3 from './images/d3.gif'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import kuva from './images/very_pissed_300x430.png'

const Scene_01_CB_PahoiteltuTunkeutumista = ({ visibilityHandler, soundsOn }) => {
    const [teksti, setTeksti] = useState('')
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [tarvittavaNopanArvo, setTarvittavaNopanArvo] = useState(null)
    const [noppaMsg, setNoppaMsg] = useState('')
    const [continuable, setContinuable] = useState(false)
    const [nextScene, setNextScene] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [closeActive, setCloseActive] = useState(false);

    const handleClose = () => setShowModal(false);
    const handleShowModal = () => {
        setShowModal(true);
        setCloseActive(false)
    }

    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {

        setTarvittavaNopanArvo(data.tarvittavaNoppaluku)
        setNoppaMsg(data.noppaMsg)
        setTeksti(data.teksti)
    }, [])


    const handleJatka = () => {

        if (nextScene != '') {
            visibilityHandler(nextScene)
        }

    }


    const handlaaArvontatulos = (e) => {
        if (e >= tarvittavaNopanArvo) {
            setNextScene('scene_01_epilogi')
        }
        else {
            setNextScene('ulos')
        }
        setCloseActive(true)//aktivoi modaalin sulkunapin
        setContinuable(true)
    }


    return (

        <div className='sceneContainer'>
            <div id='image'>
                <img className='fitted' src={kuva} alt='kuva' />
            </div>

            <div id='question'>
                <h5>{(teksti != null && teksti != "") ? teksti : null}</h5>

            </div>

            <div id='actions'>
                {noppaMsg + tarvittavaNopanArvo}

                <br />
                <img src={d3} alt='noppa_3' onClick={handleShowModal} style={{ width: '50px' }} />
                {/* <>
                    <Button variant="primary" onClick={handleShowModal}>
                        Heitä noppaa (modaali)
                    </Button>
                </> */}
                <br />
                {nextScene}
                <Modal
                    show={showModal}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >


                    {/* <Modal.Header closeButton>
                                <Modal.Title>Modal title</Modal.Title>
                            </Modal.Header> */}
                    <Modal.Body>
                        <Noppa
                            soundsOn={soundsOn}
                            handlaa={handlaaArvontatulos}
                            tarvittavaNopanArvo={tarvittavaNopanArvo}
                        // sulku={handleClose}
                        />


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}
                            disabled={!closeActive}
                        >
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>

                <div>
                    <button disabled={!continuable} onClick={() => handleJatka()}>Jatka</button>
                </div>
            </div>
        </div>
    )

}


export default Scene_01_CB_PahoiteltuTunkeutumista